import styled from 'styled-components';

const PercentCircleContainer = styled.div`
  margin-top: 10px;
  position: relative;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #ffffff;
  z-index: 1;
  svg {
    position: relative;
    width: 50px;
    height: 50px;
    z-index: 1;
    transform: rotate(-85deg);
  }
  svg circle {
    width: 49px;
    height: 49px;
    fill: none;
    stroke: #d8d8d8;
    stroke-width: 5;
    stroke-linecap: round;
    transform: translate(5px, 5px);
  }
  svg circle:nth-child(2) {
    stroke-dasharray: ${(props) => props.percent === 100 ? "130" : "126"};
    stroke-dashoffset: 126;
  }
  svg circle:nth-child(2) {
    stroke-dashoffset: calc(
      126 - (126 * ${({ percent }) => (percent ? percent : 100)}) / 100
    );
    stroke: ${({ cancel }) => (cancel ? '#FD0000' : '#a540e3')};
  }
  .number {
    font-size: 10px;
    text-align: center;
    margin-top: -33px;
    color: #707070;
  }
`;

export default PercentCircleContainer;
